import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import { useState } from 'react';
import useClickOutside from '../../Hooks/useClickOutside';
import { stakedNFTs, stakeNftData } from '../../Shared/MintNftAndStakingNftData';

import metamask from '../../assets/images/login/metamask.svg';

export interface INftStakingProps {
}

export function NftStaking(props: INftStakingProps) {

    const [sortByModalOpen, setSortByModalOpen] = useState(false)
    const [sortModalText, setSortModalText] = useState('')
    const sortByModalRef = useRef(null)
    useClickOutside(sortByModalRef, () => setSortByModalOpen(false))


    // details open----------------------------
    const stakeNftDetailsRefs = React.useRef(new Array())
    const [clickedNftDetailsIndex, setClickedNftDetailsIndex] = useState(-1)
    const [isDetailsOpen, setIsDetailsOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: stakeNftDetailsRefs.current[clickedNftDetailsIndex] }, () => {
        const newVisibilities = [...isDetailsOpen];
        newVisibilities[clickedNftDetailsIndex] = false;
        setIsDetailsOpen(newVisibilities);
    })

    const hanldeNftDetailsOpenBtn = (index: any) => {
        const newVisibilities = [...isDetailsOpen];
        newVisibilities[index] = !newVisibilities[index];
        setIsDetailsOpen(newVisibilities);
        setClickedNftDetailsIndex(index)
    };

    useEffect(() => {
        const arrayData = stakeNftDetailsRefs.current.map((data, index) => `${index}`)
        setIsDetailsOpen(() => arrayData.map((x) => false));
    }, [])



    // Staked NFT Modal ------------------------------------
    const [stakedNFTModalOpen, setStakedNFTModalOpen] = useState(false);
    const stakedNFTModalRef = useRef(null);
    useClickOutside(stakedNFTModalRef, () => setStakedNFTModalOpen(false));

    // Staked NFT Input Open
    const stakedNftInputRefs = React.useRef(new Array())
    const [clickedStakedNftInputIndex, setClickedStakedNftInputIndex] = useState(-1)
    const [stakedNFTOpen, setStakedNFTOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: stakedNftInputRefs.current[clickedStakedNftInputIndex] }, () => {
        const newVisibilities = [...stakedNFTOpen];
        newVisibilities[clickedStakedNftInputIndex] = false;
        setStakedNFTOpen(newVisibilities);
    })

    const hanldeStakedNftInputOpenBtn = (index: any) => {
        const newVisibilities = [...stakedNFTOpen];
        newVisibilities[index] = !newVisibilities[index];
        setStakedNFTOpen(newVisibilities);
        setClickedStakedNftInputIndex(index)
    };

    useEffect(() => {
        const arrayData = stakedNftInputRefs.current.map((data, index) => `${index}`)
        setStakedNFTOpen(() => arrayData.map((x) => false));
    }, [])




    // Owned NFTs moadl-----------------------------------------
    const [ownedNftModalOpen, setOwnedNftModalOpen] = useState(false);
    const ownedNftModalRef = useRef(null);
    useClickOutside(ownedNftModalRef, () => setOwnedNftModalOpen(false));

    // Owned NFTs Input Open
    const ownedNftRefs = React.useRef(new Array())
    const [clickedownedNftIndex, setClickedownedNftIndex] = useState(-1)
    const [ownedNFTOpen, setOwnedNFTOpen] = React.useState(() => [].map((x) => false));

    useClickOutside({ current: ownedNftRefs.current[clickedownedNftIndex] }, () => {
        const newVisibilities = [...ownedNFTOpen];
        newVisibilities[clickedownedNftIndex] = false;
        setOwnedNFTOpen(newVisibilities);
    })

    const hanldeownedNftOpenBtn = (index: any) => {
        const newVisibilities = [...ownedNFTOpen];
        newVisibilities[index] = !newVisibilities[index];
        setOwnedNFTOpen(newVisibilities);
        setClickedownedNftIndex(index)
    };

    useEffect(() => {
        const arrayData = ownedNftRefs.current.map((data, index) => `${index}`)
        setOwnedNFTOpen(() => arrayData.map((x) => false));
    }, [])



    return (
        <div className="nft_min_main_box mt-16 mx-auto xs:px-5 sm:px-0 pb-28
        pt-[64px]
        sm:pt-[80px] sm:max-w-[570px]
        md:max-w-[660px]
        lg:max-w-[870px]
        xl:max-w-[1100px]
        2xl:max-w-[1336px]
        3xl:max-w-[1436px] text-left">

            <div>
                <div className="relative inline-block">
                    <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">NFT Staking</h1>
                    <div className="bottom-1 absolute -right-4">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                            <defs>
                                <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                    <stop offset={0} stopColor="#00dbff" />
                                    <stop offset="0.529" stopColor="#e315e8" />
                                    <stop offset={1} stopColor="#ffd817" />
                                </linearGradient>
                            </defs>
                            <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                        </svg>
                    </div>
                </div>
                <p className="text-l-LightBlack dark:text-white mt-1 font-medium text-xxs xxsm:text-xs sm:text-sm lg:text-base 2xl:text-lg">Stake NFTs to earn tokens. <span className="
                text-cusBlack font-bold dark:font-medium dark:text-cusLink">The highest APR, good chance.</span></p>
            </div>



            <div className="flex xl:flex-row flex-col justify-between items-start xl:items-center mt-5 sm:mt-9 md:mt-14">
                <div className="flex sm:flex-row flex-col justify-start items-center w-full sm:w-auto">
                    <div className="flex justify-start items-center sm:mr-6 w-full sm:w-auto">
                        <div className="flex items-center justify-center">
                            <label htmlFor="nftMitn_stakedOnly" className="flex items-center cursor-pointer">
                                <div className="relative">
                                    <input type="checkbox" id="nftMitn_stakedOnly" name="stakedOnly" className="sr-only" />
                                    <div className="block w-16 h-8 rounded-full toogle_btn_bg" />
                                    <div className="dot absolute left-1.5 top-1 w-6 h-6 rounded-full transition" />
                                </div>
                            </label>
                        </div>
                        <label htmlFor="nftMitn_stakedOnly">
                            <p className="text-cusBlack dark:text-white font-semibold ml-3 text-xl select-none">Staked only</p>
                        </label>
                    </div>

                    <div className="bg-[#fff] dark:bg-[#232057] rounded-full p-0.5 w-full sm:w-auto mt-3 sm:mt-0
                    filter drop-shadow-md flex justify-start items-center order-2 sm:order-1">
                        <label className="cursor-pointer w-full">
                            <input type="radio" defaultChecked name="nftMintState" id="nftMint_live" className="peer hidden" />
                            <p className="font-semibold px-7 py-2 rounded-full
                        from-[#00DBFF] via-[#E315E8] to-[#FFD817] w-full text-center
                        peer-checked:bg-gradient-to-br text-cusBlack dark:text-white peer-checked:text-white text-sm sm:text-lg">Live</p>
                        </label>

                        <label className="cursor-pointer ml-2 w-full">
                            <input type="radio" name="nftMintState" id="nftMint_finished" className="peer hidden" />
                            <p className="font-semibold px-7 py-2 rounded-full
                        from-[#00DBFF] via-[#E315E8] to-[#FFD817]  w-full text-center
                        peer-checked:bg-gradient-to-br text-cusBlack dark:text-white peer-checked:text-white text-sm sm:text-lg">Finished</p>
                        </label>
                    </div>
                </div>



                <div className="flex sm:flex-row flex-col justify-end items-center mt-4 xl:mt-0 w-full xl:w-auto">

                    <div className="relative sm:mr-4 mb-3 xl:mb-0 w-full sm:w-auto">
                        <div className="flex justify-center items-center px-6 py-2.5 rounded-full shadow-md
                         border border-[#DDE3EE] dark:border-[#333074] bg-white dark:bg-[#232057]
                         cursor-pointer"
                            ref={sortByModalRef}
                            onClick={() => setSortByModalOpen(!sortByModalOpen)}
                        >
                            <svg id="Group_36" data-name="Group 36" xmlns="http://www.w3.org/2000/svg" className="w-4" viewBox="0 0 16.454 16.173">
                                <path className="w-4 fill-[#0d0d0d] dark:fill-[#c8c8c9]" id="Path_26" data-name="Path 26" d="M18.147,27.614h-.932V18.147H12.071l6.076-6.076Zm-3.827-10.4h2.9v-2.9Z" transform="translate(-11.625 -11.625)" fill="" />
                                <path className="w-4 fill-[#0d0d0d] dark:fill-[#c8c8c9]" id="Path_27" data-name="Path 27" d="M2.249,5.776H5.775V2.25ZM6.337.893V15.8H5.775V6.338H.892ZM6.707,0,0,6.708H5.406v9.467h1.3Z" transform="translate(0 -0.001)" fill="" />
                                <path className="w-4 fill-[#0d0d0d] dark:fill-[#c8c8c9]" id="Path_28" data-name="Path 28" d="M268.688,20.542V5h.932v9.467h5.144Zm.932-5.144v2.9l2.9-2.9Z" transform="translate(-258.756 -4.815)" fill="" />
                                <path className="w-4 fill-[#0d0d0d] dark:fill-[#c8c8c9]" id="Path_29" data-name="Path 29" d="M264.989,13.033Zm-.37-2.634v3.526l3.526-3.526ZM264.058.371h.562V9.837H269.5l-5.445,5.445Zm-.37-.37V16.174l6.707-6.707h-5.406V0Z" transform="translate(-253.941 -0.001)" fill="" />
                            </svg>
                            <p className="text-cusBlack dark:text-white truncate font-semibold ml-2 mr-3">Sort By</p>
                            <svg xmlns="http://www.w3.org/2000/svg" className={`w-3 stroke-[#310063] dark:stroke-[#c8c8c9] ${sortByModalOpen ? 'rotate-180' : ''} transition-all`} viewBox="0 0 10.18 6.09">
                                <path id="Path" d="M0,0,3.676,3.676,7.352,0" transform="translate(1.414 1.414)" fill="none" stroke=""
                                    strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                            </svg>
                        </div>

                        <AnimatePresence>
                            {sortByModalOpen &&
                                <motion.div
                                    animate={sortByModalOpen ? "open" : "closed"}
                                    initial={{ y: -15, }}
                                    variants={{
                                        open: { y: 0, },
                                        closed: { y: -100, },
                                    }}
                                    exit={{ opacity: 0, y: -15 }}
                                    transition={{ duration: 0.2 }}
                                    className="rounded-xl overflow-hidden absolute top-11 xl:top-12 bg-white dark:bg-[#292757] shadow-lg
                                                        dark:shadow-[#00000060] border border-[#e6e8ec] dark:border-[#e6e8ec20] w-full left-0 z-20
                                                        min-w-[120px] sm:min-w-[150px] cursor-pointer">
                                    {['Hot', 'ARP', 'Earned', 'Total staked',].map(item =>
                                        <div onClick={() => { setSortModalText(item) }}
                                            className={`py-2 px-4 break-all hover:bg-[#e6e8ec] dark:hover:bg-cusBlack transition-all`} key={item}>
                                            <p className="text-cusBlack dark:text-white text-xs lg:text-sm xl:text-base font-medium
                                                        whitespace-nowrap overflow-hidden overflow-ellipsis">{item}</p>
                                        </div>
                                    )}
                                </motion.div>}
                        </AnimatePresence>
                    </div>



                    <div className="bg-[#fff] dark:bg-[#232057] rounded-full filter drop-shadow-md
                        flex justify-start items-center order-1 sm:order-2 mb-3 sm:mb-0 w-full
                        px-4 py-3.5">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 sm:w-5" viewBox="0 0 20.207 20.207">
                                <g id="search" transform="translate(1 1)">
                                    <circle id="Oval" cx="7.908" cy="7.908" r="7.908" transform="translate(0 0)" fill="none" stroke="#c8c8c9" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                                    <path id="Path" d="M4.3,4.3,0,0" transform="translate(13.493 13.493)" fill="none" stroke="#c8c8c9" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                                </g>
                            </svg>
                        </div>

                        <input
                            type="text" name="" id=""
                            placeholder="Search pools..."
                            className="bg-transparent text-xs xsm:text-sm md:text-base outline-none ml-3
                            w-full sm:w-44 sm:focus:w-60 lg:focus:w-64 xl:focus:w-72 2xl:focus:w-80 h-full
                        text-cusBlack dark:text-white transition-all duration-500" />
                    </div>
                </div>

            </div>






            <div className="mt-10 grid grid-cols-1 xsm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5
            gap-x-3 gap-y-6">
                {stakeNftData.map((stakeNFT, index) =>
                    <div
                        key={stakeNFT.id}
                        className="rounded-md md:rounded-lg xl:rounded-xl lightBlueBg overflow-hidden p-1.5 shadow-xl h-fit"
                    >
                        <div className="w-full
                         h-[200px] xxsm:h-[298px] xsm:h-[230px] sm:h-[268px] md:h-[308px] lg:h-[268px] xl:h-[248px] 3xl:h-[268px]
                        rounded-md md:rounded-lg xl:rounded-xl overflow-hidden group">
                            <img src={stakeNFT.nftImage} alt="" className="w-full h-full object-cover group-hover:scale-125 transition-all duration-300" />
                        </div>



                        <div className="mt-3 text-center px-5">

                            <div className="flex justify-between items-center">
                                <h5 className="text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white">APR</h5>
                                <div className="flex justify-end items-center">
                                    <h5 className="text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white mr-2 ">{stakeNFT.apr}% </h5>

                                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 sm:w-5 fill-[#000] dark:fill-white" viewBox="0 0 17.619 17.619">
                                        <g id="Group_3933" data-name="Group 3933" transform="translate(0 0)">
                                            <path id="Path_1768" data-name="Path 1768" d="M15.682,1H3.936A2.94,2.94,0,0,0,1,3.936V15.682a2.94,2.94,0,0,0,2.936,2.936H15.682a2.94,2.94,0,0,0,2.936-2.936V3.936A2.94,2.94,0,0,0,15.682,1Zm1.762,2.936V9.222H10.4V2.175h5.286A1.764,1.764,0,0,1,17.444,3.936ZM3.936,2.175H9.222V9.222H2.175V3.936A1.764,1.764,0,0,1,3.936,2.175ZM2.175,15.682V10.4H9.222v7.047H3.936A1.764,1.764,0,0,1,2.175,15.682Zm13.508,1.762H10.4V10.4h7.047v5.286A1.764,1.764,0,0,1,15.682,17.444Z" transform="translate(-1 -1)" />
                                            <path id="Path_1769" data-name="Path 1769" d="M5.587,7.936H6.762V9.111a.587.587,0,1,0,1.175,0V7.936H9.111a.587.587,0,0,0,0-1.175H7.936V5.587a.587.587,0,1,0-1.175,0V6.762H5.587a.587.587,0,0,0,0,1.175Z" transform="translate(-2.651 -2.651)" />
                                            <path id="Path_1770" data-name="Path 1770" d="M19.587,9.175h3.524a.587.587,0,0,0,0-1.175H19.587a.587.587,0,0,0,0,1.175Z" transform="translate(-8.429 -3.889)" />
                                            <path id="Path_1771" data-name="Path 1771" d="M23.111,24H19.587a.587.587,0,0,0,0,1.175h3.524a.587.587,0,0,0,0-1.175Z" transform="translate(-8.429 -10.492)" />
                                            <path id="Path_1772" data-name="Path 1772" d="M23.111,20H19.587a.587.587,0,0,0,0,1.175h3.524a.587.587,0,0,0,0-1.175Z" transform="translate(-8.429 -8.841)" />
                                            <path id="Path_1773" data-name="Path 1773" d="M8.542,21.712l.83-.83a.587.587,0,0,0-.83-.83l-.83.83-.83-.83a.587.587,0,0,0-.83.83l.83.83-.83.831a.587.587,0,1,0,.83.83l.83-.83.83.83a.587.587,0,0,0,.83-.83Z" transform="translate(-3.014 -8.791)" />
                                        </g>
                                    </svg>
                                </div>
                            </div>

                            <div className="flex justify-between items-center mt-1">
                                <h5 className="text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white">Deposit Fee</h5>
                                <h5 className="text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white">{stakeNFT.depositFee}%</h5>
                            </div>

                            <div className="flex justify-between items-center mt-1">
                                <h5 className="text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white">Earn</h5>
                                <h5 className="text-xs sm:text-sm 2xl:text-base text-cusBlack dark:text-white">{stakeNFT.earn}</h5>
                            </div>
                        </div>


                        <div className="px-5 mb-5">
                            <div className="w-full flex justify-between items-center mt-4">
                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Staked NFTs (0)</p>
                                <button className="gradientBtn px-3 py-1.5 rounded-md text-white text-sm"
                                    onClick={() => setStakedNFTModalOpen(!stakedNFTModalOpen)}
                                >
                                    Unstake
                                </button>
                            </div>

                            <div className="w-full flex justify-between items-center mt-4">
                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Owned NFTs (0)</p>
                                <button className="gradientBtn px-3 py-1.5 rounded-md text-white text-sm"
                                    onClick={() => setOwnedNftModalOpen(!ownedNftModalOpen)}>
                                    Stake
                                </button>
                            </div>

                        </div>


                        <div className="bg-[#cad2e164] dark:bg-[#3b316e98] px-5 py-4 mt-2 flex justify-between items-center">
                            <div className="">
                                <p className="text-[#6640FF] dark:text-[#1fc4d2] font-medium">USDT EARNED</p>

                                <div className="flex justify-start items-center">
                                    <p className="text-cusBlack dark:text-white font-semibold mr-2 text-lg">{stakeNFT.usdtEarn.toFixed(2)}</p>
                                    <p className="text-[#8A8A8A] dark:text-cusBlueWhite text-xs">~{stakeNFT.usdtEarn.toFixed(2)} USD</p>
                                </div>
                            </div>
                        </div>



                        <div className="px-4">

                            <p className="text-l-LightBlack dark:text-cusBlueWhite text-sm mt-3">STAKE <span className="text-[#6640FF] dark:text-[#1fc7d4]">{stakeNFT.stake}</span></p>

                            <motion.div
                                whileHover={{ scale: 1.08, }}
                                whileTap={{ scale: 1 }}
                                className="rounded-full bg-gradient-to-l p-[3px] mt-2 sm:mt-3
                                from-[#00DBFF] via-[#E315E8] to-[#FFD817]  w-full text-center">

                                <button className="w-full py-1 sm:py-1.5 md:py-2 text-cusBlack dark:text-white
                                font-semibold dark:bg-[#1d1b4b] bg-white rounded-full">
                                    Enable
                                </button>
                            </motion.div>




                            <div className="mt-3 sm:mt-5 pb-3"
                                ref={(el) => stakeNftDetailsRefs.current[index] = el}>
                                <div className="flex justify-center items-center cursor-pointer"
                                    onClick={() => hanldeNftDetailsOpenBtn(index)}
                                >
                                    <p className="text-cusBlack dark:text-[#1fc7d4] font-bold mr-1 select-none text-sm md:text-base">
                                        {isDetailsOpen[index] ? "Hide" : "Details"}
                                    </p>
                                    <svg xmlns="http://www.w3.org/2000/svg" className={`w-3 stroke-[#310063] dark:stroke-[#1fc7d4] ${isDetailsOpen[index] ? 'rotate-180' : ''} transition-all`} viewBox="0 0 10.18 6.09">
                                        <path id="Path" d="M0,0,3.676,3.676,7.352,0" transform="translate(1.414 1.414)" fill="none" stroke=""
                                            strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit={10} strokeWidth={2} />
                                    </svg>
                                </div>

                                <AnimatePresence>
                                    {isDetailsOpen[index] &&
                                        <motion.div
                                            initial={{ height: 0 }}
                                            animate={{ height: 'auto' }}
                                            exit={{ height: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="overflow-hidden">



                                            <div className="flex justify-between items-center mt-4">
                                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Total staked:</p>
                                                <p className="text-xs 2xl:text-sm text-cusBlack dark:text-white font-medium">{stakeNFT.details.totalStaked} DNFT</p>
                                            </div>

                                            <div className="flex justify-between items-center mt-1">
                                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Max. stake per user:</p>
                                                <p className="text-xs 2xl:text-sm text-cusBlack dark:text-white font-medium">{stakeNFT.details.maxStakePerUser} DNFT</p>
                                            </div>

                                            <div className="flex justify-between items-center mt-1">
                                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Deposit fee per item:</p>
                                                <p className="text-xs 2xl:text-sm text-cusBlack dark:text-white font-medium">{stakeNFT.details.depositFeePerItem} BNB</p>
                                            </div>

                                            <div className="flex justify-between items-center mt-1">
                                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Withdraw fee per item:</p>
                                                <p className="text-xs 2xl:text-sm text-cusBlack dark:text-white font-medium">{stakeNFT.details.withdrawFeePerItem} BNB</p>
                                            </div>

                                            <div className="flex justify-between items-center mt-1">
                                                <p className="text-xs 2xl:text-sm text-l-LightBlack dark:text-white font-normal">Ends in:</p>
                                                <p className="text-xs 2xl:text-sm text-cusBlack dark:text-white font-medium">{stakeNFT.details.endsIn} Blocks</p>
                                            </div>

                                            <a href="#" className="flex justify-end items-center mt-3 ">
                                                <p className="dark:text-cusLink mr-2 text-xs 2xl:text-sm hover:border-b border-[#000] dark:border-cusLink text-cusBlack">View Project Site</p>

                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 sm:h-4 sm:w-4 stroke-cusBlack dark:stroke-cusLink" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                                </svg>
                                            </a>

                                            <a href="#" className="flex justify-end items-center mt-1">
                                                <p className="dark:text-cusLink mr-2 text-xs 2xl:text-sm hover:border-b border-[#000] dark:border-cusLink text-cusBlack">
                                                    View Contract
                                                </p>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 sm:h-4 sm:w-4 stroke-cusBlack dark:stroke-cusLink" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                                                </svg>
                                            </a>

                                            <a href="#" className="flex justify-end items-center mt-1">
                                                <p className="dark:text-cusLink mr-2 text-xs 2xl:text-sm hover:border-b border-[#000] dark:border-cusLink text-cusBlack">
                                                    Add to Metamask
                                                </p>
                                                <img src={metamask} alt="" className="w-4" />
                                            </a>




                                        </motion.div>
                                    }
                                </AnimatePresence>

                            </div>

                        </div>

                    </div>
                )}



            </div>








            <AnimatePresence>
                {stakedNFTModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={stakedNFTModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={stakedNFTModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle
                                max-w-sm sm:max-w-md md:max-w-lg w-full">

                                <div className="flex justify-between items-center px-6 pt-5 mb-4">
                                    <div className="relative inline-block">
                                        <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Staked NFTs</h1>
                                        <div className="bottom-1 absolute -right-4">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                                <defs>
                                                    <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                                        <stop offset={0} stopColor="#00dbff" />
                                                        <stop offset="0.529" stopColor="#e315e8" />
                                                        <stop offset={1} stopColor="#ffd817" />
                                                    </linearGradient>
                                                </defs>
                                                <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                                            </svg>
                                        </div>
                                    </div>

                                    <button onClick={() => setStakedNFTModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG2 w-4 xl:w-5" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>


                                <div className="px-6 pb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 h-auto gap-x-2 gap-y-2 max-h-[400px] overflow-auto">

                                    {stakedNFTs.map((nft, index) =>
                                        <div className="overflow-hidden rounded-md relative cursor-pointer"
                                            key={nft.id}>

                                            <div className="absolute top-0 right-0 bg-[#766bda] p-2 rounded-bl-lg">
                                                <p className="text-white text-xs">#{
                                                    nft.tokenID.length > 9
                                                        ? `${nft.tokenID.slice(0, 4)}...${nft.tokenID.slice(nft.tokenID.length - 4, nft.tokenID.length)}`
                                                        : nft.tokenID
                                                }</p>
                                            </div>
                                            <div className="w-full sm:h-[190px] md:h-[145px]"
                                                onClick={() => hanldeStakedNftInputOpenBtn(index)}
                                            >
                                                <img src={nft.nftPhoto} alt="" className="w-full h-full object-cover" />
                                            </div>


                                            <AnimatePresence>
                                                {stakedNFTOpen[index] &&
                                                    <motion.div
                                                        initial={{ height: 0 }}
                                                        animate={{ height: '' }}
                                                        exit={{ height: 0 }}
                                                        className="w-full px-0.5">
                                                        <input
                                                            type="text"
                                                            name=""
                                                            id=""
                                                            placeholder="Type here..."
                                                            className="form-input my-2 bg-transparent bg-white dark:bg-[#1c1735] duration-300
                                                    text-cusBlack dark:text-white outline-none w-full rounded-md transition-all text-sm sm:text-xs md:text-sm" />
                                                    </motion.div>}
                                            </AnimatePresence>
                                        </div>
                                    )
                                    }
                                </div>


                                <div className="p-6 text-right">
                                    <button
                                        onClick={() => setStakedNFTModalOpen(false)}
                                        className="border-2 border-cusBlack dark:border-cusBlueWhite text-cusBlack dark:text-white
                                                px-6 md:px-8  py-[7px] md:py-[8px] rounded-md font-bold mr-4 text-sm">
                                        Close
                                    </button>
                                </div>

                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>


            <AnimatePresence>
                {ownedNftModalOpen &&
                    <div
                        className="fixed z-50 inset-0 overflow-y-auto " aria-labelledby="modal-title" role="dialog" aria-modal="true">
                        <div className="flex items-center justify-center min-h-screen text-center sm:block sm:p-0">
                            <div className="fixed inset-0 backdrop-blur-lg bg-gray-900 bg-opacity-75 transition-opacity" aria-hidden="true" />
                            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">​</span>

                            <motion.div
                                animate={ownedNftModalOpen ? "open" : "closed"}
                                initial={{ scale: 0.7 }}
                                variants={{
                                    open: { scale: 1 },
                                    closed: { scale: 0.9 },
                                }}
                                exit={{ scale: 0 }}
                                transition={{ duration: 0.1 }}
                                ref={ownedNftModalRef}
                                className="relative inline-block align-bottom bg-white dark:bg-[#292757]
                                rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:align-middle
                                max-w-sm sm:max-w-md md:max-w-lg w-full">

                                <div className="flex justify-between items-center px-6 pt-5 mb-4">
                                    <div className="relative inline-block">
                                        <h1 className="xs:text-xl sm:text-2xl xl:text-3xl mr-3 font-extrabold text-cusBlack dark:text-white">Owned NFTs</h1>
                                        <div className="bottom-1 absolute -right-4">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={12} height={12} viewBox="0 0 12 12">
                                                <defs>
                                                    <linearGradient id="linear-gradient" x1="0.875" y1="0.174" x2="0.139" y2="0.84" gradientUnits="objectBoundingBox">
                                                        <stop offset={0} stopColor="#00dbff" />
                                                        <stop offset="0.529" stopColor="#e315e8" />
                                                        <stop offset={1} stopColor="#ffd817" />
                                                    </linearGradient>
                                                </defs>
                                                <circle id="Ellipse_1" data-name="Ellipse 1" cx={6} cy={6} r={6} fill="url(#linear-gradient)" />
                                            </svg>
                                        </div>
                                    </div>

                                    <button onClick={() => setOwnedNftModalOpen(false)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="blackWhiteSVG2 w-4 xl:w-5" viewBox="0 0 21.855 21.856">
                                            <line id="Line_74" data-name="Line 74" x2="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                            <line id="Line_75" data-name="Line 75" x1="17.613" y2="17.613" transform="translate(2.121 2.121)" fill="none" stroke="#fcfcfc" strokeLinecap="round" strokeWidth={3} />
                                        </svg>
                                    </button>
                                </div>


                                <div className="px-6 pb-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 h-auto gap-x-2 gap-y-2 max-h-[400px] overflow-auto">

                                    {stakedNFTs.map((nft, index) =>
                                        <div className="overflow-hidden rounded-md relative cursor-pointer"
                                            key={nft.id}>

                                            <div className="absolute top-0 right-0 bg-[#766bda] p-2 rounded-bl-lg">
                                                <p className="text-white text-xs">#{
                                                    nft.tokenID.length > 9
                                                        ? `${nft.tokenID.slice(0, 4)}...${nft.tokenID.slice(nft.tokenID.length - 4, nft.tokenID.length)}`
                                                        : nft.tokenID
                                                }</p>
                                            </div>
                                            <div className="w-full sm:h-[190px] md:h-[145px]"
                                                onClick={() => hanldeownedNftOpenBtn(index)}
                                            >
                                                <img src={nft.nftPhoto} alt="" className="w-full h-full object-cover" />
                                            </div>


                                            <AnimatePresence>
                                                {ownedNFTOpen[index] &&
                                                    <motion.div
                                                        initial={{ height: 0 }}
                                                        animate={{ height: '' }}
                                                        exit={{ height: 0 }}
                                                        className="w-full px-0.5">
                                                        <input
                                                            type="text"
                                                            name=""
                                                            id=""
                                                            placeholder="Type here..."
                                                            className="form-input my-2 bg-transparent bg-white dark:bg-[#1c1735] duration-300
                                                    text-cusBlack dark:text-white outline-none w-full rounded-md transition-all text-sm sm:text-xs md:text-sm" />
                                                    </motion.div>}
                                            </AnimatePresence>
                                        </div>
                                    )
                                    }
                                </div>


                                <div className="p-6 text-right">
                                    <button
                                        onClick={() => setOwnedNftModalOpen(false)}
                                        className="border-2 border-cusBlack dark:border-cusBlueWhite text-cusBlack dark:text-white
                                                px-6 md:px-8  py-[7px] md:py-[8px] rounded-md font-bold mr-4 text-sm">
                                        Close
                                    </button>
                                </div>

                            </motion.div>
                        </div>
                    </div>
                }
            </AnimatePresence>















        </div>
    );
}
